module.exports = __webpack_public_path__ + "static/media/IMG_4607.868510a0.jpg";